import React from "react"

export default ({ source }, railsContext) => {
  return () => (
    <div>
      <h1>Love.irish app</h1>
    </div>
  )
}
